export default class SuggestionItemApiModel {
  public static mapToBusinessModel(apiModel: SuggestionItemApiModel): string {
    return apiModel.suggestion;
  }

  public suggestion!: string;
  public type!: string;
  public distance!: number;
}
